module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"contents":{"podcasts":{"meta_tags":{"description":"CAPinside has something for your ears! Exciting investment stories from influencers and experts from the industry.","title":"Podcasts"},"teaser":"Listen to our audio content with exciting guests from the world of finance and the fund industry.","title":"Podcasts"}}}}}}')
  delete Component.options._Ctor
}
